<section class="breadcrumb-section-main inner-2 breadcrumb-section-sm">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="breadcrumb-contain ">
                    <div>
                        <h2 class="breadcrumb-txt">Kontakt</h2>
                    </div>
                    <div>
                        <ul>
                            <li><a href="#">Startseite</a></li>
                            <li><a href="#"><i class="fa fa-angle-double-right"></i> Kontakt</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section id="how-work" class="saas1 howitwork" [ngStyle]="{'background-image': 'url(assets/images/saas1/work-bg.png)'}">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center">
                <div class="title">
                    <img src="../../../../assets/images/saas1/title-logo.png" alt="title-logo" class="img-fluid">
                    <div class="main-title">
                        <h2>Kontakt Aufnahme</h2>
                    </div>
                    <hr>
                    <div class="sub-title">
                        <p class="p-padding">
                            Wir freuen uns, dass Sie mit uns in Kontakt treten möchten. Nutzen Sie einfach das untenstehende Formular, um uns Ihre Informationen und Nachricht zukommen zu lassen. <br>
                            Unser Team wird sich so schnell wie möglich bei Ihnen melden, um Ihr Anliegen zu bearbeiten.<br>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="music bg-footer" [ngStyle]="{'background-image': 'url(assets/images/music/footer-bg.jpg)'}">
    <div class="container">

        <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
            <div class="form form-footer p-t-50">
                <div class="row">
                    <!-- Vorname -->
                    <div class="col-sm-6">
                        <div class="form-group ">
                            <input type="text"
                                   placeholder="Vorname"
                                   formControlName="firstName"
                                   class="form-control bg-light-gray"
                                   [class.is-invalid]="contactForm.get('firstName').invalid && contactForm.get('firstName').touched">
                            <div *ngIf="contactForm.get('firstName').invalid && contactForm.get('firstName').touched" class="invalid-feedback">
                                Vorname ist erforderlich.
                            </div>
                        </div>
                    </div>
                    <!-- Nachname -->
                    <div class="col-sm-6">
                        <div class="form-group">
                            <input type="text"
                                   placeholder="Nachname"
                                   formControlName="lastName"
                                   class="form-control"
                                   [class.is-invalid]="contactForm.get('lastName').invalid && contactForm.get('lastName').touched">
                            <div *ngIf="contactForm.get('lastName').invalid && contactForm.get('lastName').touched" class="invalid-feedback">
                                Nachname ist erforderlich.
                            </div>
                        </div>
                    </div>
                    <!-- Firmenname -->
                    <div class="col-sm-6">
                        <div class="form-group">
                            <input type="text"
                                   placeholder="Firmen Name"
                                   formControlName="companyName"
                                   class="form-control"
                                   [class.is-invalid]="contactForm.get('companyName').invalid && contactForm.get('companyName').touched">
                            <div *ngIf="contactForm.get('companyName').invalid && contactForm.get('companyName').touched" class="invalid-feedback">
                                Firmenname ist erforderlich.
                            </div>
                        </div>
                    </div>
                    <!-- Email -->
                    <div class="col-sm-6">
                        <div class="form-group">
                            <input type="email"
                                   placeholder="Email"
                                   formControlName="email"
                                   class="form-control"
                                   [class.is-invalid]="contactForm.get('email').invalid && contactForm.get('email').touched">
                            <div *ngIf="contactForm.get('email').errors?.['required'] && contactForm.get('email').touched" class="invalid-feedback">
                                Email ist erforderlich.
                            </div>
                            <div *ngIf="contactForm.get('email').errors?.['email'] && contactForm.get('email').touched" class="invalid-feedback">
                                Ungültige Email-Adresse.
                            </div>
                        </div>
                    </div>
                    <!-- Nachricht -->
                    <div class="col-12">
                        <div class="form-group">
                            <textarea class="form-control"
                                      rows="12"
                                      placeholder="Nachricht"
                                      formControlName="message"
                                      [class.is-invalid]="contactForm.get('message').invalid && contactForm.get('message').touched"></textarea>
                            <div *ngIf="contactForm.get('message').errors?.['required'] && contactForm.get('message').touched" class="invalid-feedback">
                                Nachricht ist erforderlich.
                            </div>
                            <div *ngIf="contactForm.get('message').errors?.['minlength'] && contactForm.get('message').touched" class="invalid-feedback">
                                Die Nachricht muss mindestens 10 Zeichen enthalten.
                            </div>
                        </div>
                    </div>
                    <!-- Button -->
                    <div class="col-12">
                        <div class="d-flex justify-content-end">
                            <button type="submit"
                                    class="btn btn-lg rounded-5 me-2 border border-1"
                                    [disabled]="contactForm.invalid">
                                Send
                            </button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-10 mx-auto">
                            <div class="mt-4">

                                <small class="text-muted d-block">
                                    <strong>Wir melden uns schnellstmöglich!</strong><br>
                                    In der Regel beantworten wir alle Anfragen innerhalb von 24 Stunden an Werktagen. Zögern Sie nicht, uns bei Rückfragen direkt zu kontaktieren.
                                </small>

                                <small class="text-muted d-block mb-2">
                                    <strong>Ihre Daten sind bei uns sicher.</strong><br>
                                    Wir verwenden Ihre Angaben ausschließlich zur Bearbeitung Ihrer Anfrage. Weitere Informationen finden Sie in unserer
                                    <a href="/datenschutz" target="_blank">Datenschutzerklärung</a>.
                                </small>
                            </div>
                        </div>
                    </div>
                    <!-- Spacer -->
                    <div class="mb-5"></div>
                </div>
            </div>
        </form>
    </div>
</section>